import _ from "lodash";
import React from "react";
import classes from "./SubHeader.scss";
import I18nHOC from "UIComponents/I18nHOC";
const subHeaderMapping = {
  RUBRIC: "assessmentEvaluation:distribution_rubric_achievement",
  CHECKLIST: "assessmentEvaluation:distribution_checklist_assessment",
  MYP_OBJECTIVE_RUBRIC:
    "assessmentEvaluation:distribution_myp_objective_rubric",
  SCORE: "assessmentEvaluation:distribution_point_based_assessment",
};

const FILTER_STUDENT_LIST = [
  { id: "total", label: "assessmentEvaluation:total_students" },
  { id: "done", label: "classRoom:evaluated" },
  { id: "pending", label: "common:pending" },
];

const SubHeader = React.memo(props => {
  const { toolType, filteredStudentCount, t } = props;

  return (
    <div className={classes.container}>
      <div className={classes.leftHeader}>{t(subHeaderMapping[toolType])}</div>
      <div className={classes.studentCountList}>
        {_.map(FILTER_STUDENT_LIST, ({ id, label }) => {
          return (
            <div className={classes.statusContainer} key={id}>
              <div className={classes.count}>{filteredStudentCount[id]}</div>
              <div className={classes.countLabel}>{t(label)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
});
SubHeader.displayName = "SubHeader";
export default I18nHOC({ resource: ["assessmentEvaluation", "common"] })(
  SubHeader
);
